<div class="modal-header">
  <h6 class="modal-title">
    Admin : Course Management : Add/ Edit Practice Test
  </h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <!-- mock-exam-form.component.html -->
  <form [formGroup]="addEditForm">
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Practice Test ID</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="text"
            id="weeklyPracticeTestId"
            class="form-control form-control-sm"
            formControlName="weeklyPracticeTestId"
          />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Test Number</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="text"
            id="practiceTestSeqNumber"
            class="form-control form-control-sm"
            formControlName="practiceTestSeqNumber"
          />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Test Name</div>
          </div>
        </div>
        <div class="col-12 col-md-6 pl-2">
          <input
            type="text"
            id="testName"
            class="form-control form-control-sm"
            formControlName="testName"
          />
          <small
            *ngIf="
              addEditForm.get('testName')?.touched &&
              addEditForm.get('testName')?.hasError('required')
            "
            style="color: red"
          >
            Field is required
          </small>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Available Date</div>
          </div>
        </div>
        <div class="col-12 col-md-3 pl-2">
          <input
            type="date"
            id="availableDate"
            min="{{ minDate }}"
            class="form-control form-control-sm"
            formControlName="availableDate"
          />
          <small
            *ngIf="
              addEditForm.get('availableDate')?.touched &&
              addEditForm.get('availableDate')?.hasError('required')
            "
            style="color: red"
          >
            Field is required
          </small>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Test Type</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <div class="d-flex gap-3">
            <div class="form-check">
              <input
                type="radio"
                class="form-check-input"
                id="monthlyTestType"
                value="MonthlyTest"
                formControlName="testType"
              />
              <label class="form-check-label" for="monthlyTestType">
                Monthly
              </label>
            </div>
            <div class="form-check">
              <input
                type="radio"
                class="form-check-input"
                id="weeklyTestType"
                value="WeeklyTest"
                formControlName="testType"
              />
              <label class="form-check-label" for="weeklyTestType">
                Weekly
              </label>
            </div>
          </div>
          <small
            *ngIf="
              addEditForm.get('testType')?.touched &&
              addEditForm.get('testType')?.hasError('required')
            "
            style="color: red"
          >
            Field is required
          </small>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15"># of Questions</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="number"
            id="noOfQuestion"
            class="form-control form-control-sm w-25 text-end"
            formControlName="noOfQuestion"
            step="1"
            min="0"
            (keypress)="preventDecimal($event)"
          />
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Total Score</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <input
            type="text"
            id="totalScore"
            class="form-control form-control-sm w-25 text-end"
            mask="separator.2"
            thousandSeparator=""
            separatorLimit="9999"
            formControlName="totalScore"
          />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Status</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <select
            id="status"
            class="form-control form-control-sm"
            formControlName="status"
          >
            <option value="">Select Status</option>
            <option *ngFor="let status of statuses" [value]="status.Code">
              {{ status.Description }}
            </option>
          </select>
          <small
            *ngIf="
              addEditForm.get('status')?.touched &&
              addEditForm.get('status')?.hasError('required')
            "
            style="color: red"
          >
            Field is required
          </small>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row pt-1">
        <div class="col-4 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 f-15">Applicable Course Plan</div>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <div class="form-check" *ngFor="let course of courses">
            <input
              type="checkbox"
              class="form-check-input"
              [disabled]="disablecheckboxes(course.Code)"
              [id]="course.Code"
              [value]="course.Code"
              [checked]="checkedCoursePlan(course.Code)"
              (change)="onCourseChange($event)"
            />
            <label class="form-check-label f-15" [for]="course.Code">{{
              course.Description
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm bl-btn" (click)="onSubmit()">
    Save
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border"
    (click)="activeModal.dismiss('Cross click')"
  >
    Cancel
  </button>
</div>
